<template>
	<nk-page commercialAccess="Sale">
		<template #badges>
			<nk-badge system="treasury">
				<nk-badge-item type="system" modelValue="treasury"></nk-badge-item>
				<nk-badge-item type="part" :modelValue="settings.targetForm" :tag="localData.transaction?.method.toLowerCase()"></nk-badge-item>
				<nk-badge-item type="section" modelValue="factor-relation"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="d-flex flex-column nk-card">
			<div class="form-container">
				<form>
					<div class="container-fluid">
						<div class="row flex-row-reverse nk-seprator">
							<div class="col-12">
								<nk-col-form-group :label="`${$t('trs.related-factor-attachments.transaction')}:`" class="mt-4" :labelSizes="{ xs: 2, sm: 2 }" :dataSizes="{ xs: 10, sm: 10 }" :labelAligns="{ xs: 'left' }">
									<nk-label :options="componentOptions.number" v-model="transaction" :tabindex="101" :disabled="true" class="current-factor text-right"></nk-label>
								</nk-col-form-group>
							</div>
							<div class="col-12">
								<nk-col-form-group :label="`${$t('sale.factor-attachments.f.attachedFactor')}:`" :double="true" class="mt-3" :labelSizes="{ xs: 2, sm: 2 }" :dataSizes="{ xs: 10, sm: 10 }" :labelAligns="{ xs: 'left' }">
									<nk-input ref="factorAttachment" v-model="attachedFactor" @searchClick="attachableFactorList" :options="componentOptions.code" :tabindex="102"></nk-input>
								</nk-col-form-group>
							</div>
							<div class="col-sm-6 col-12">
								<nk-col-form-group :label="`${$t('sale.factor-attachments.f.factorPayableAmount')}:`" :double="true" class="mt-3" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }" :labelAligns="{ xs: 'left' }">
									<nk-input v-model="localData.factorHeader.totalPayableAmount" :options="componentOptions.price" :disabled="true" :tabindex="103"></nk-input>
									<template #hint>
										<nk-label v-model="localData.factorHeader.totalPayableAmount" :options="{ type: 'price-letter' }" class="px-1 text-right"></nk-label>
									</template>
								</nk-col-form-group>
							</div>
							<div class="col-sm-6 col-12">
								<nk-col-form-group :label="`${$t('sale.factor.f.totalUnpaid')} ${$t('sale.factor.factor')}:`" :double="true" class="mt-3" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }" :labelAligns="{ xs: 'left' }" style="padding-right:9px">
									<nk-input v-model="localData.factorHeader.totalUnpaid" :options="componentOptions.price" :disabled="true" :tabindex="105"></nk-input>
									<template #hint>
										<nk-label v-model="localData.factorHeader.totalUnpaid" :options="{ type: 'price-letter' }" class="px-1 text-right"></nk-label>
									</template>
								</nk-col-form-group>
							</div>
							<div class="col-sm-6 col-12">
								<nk-col-form-group :label="`${$t('sale.factor-attachments.f.attachable-amount')}:`" :double="true" class="mt-3" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }" :labelAligns="{ xs: 'left' }">
									<nk-input v-model="attachableAmount" :options="componentOptions.price" :disabled="true" :tabindex="106"></nk-input>
									<template #hint>
										<nk-label v-model="attachableAmount" :options="{ type: 'price-letter' }" class="px-1 text-right"></nk-label>
									</template>
								</nk-col-form-group>
							</div>
							<div class="col-sm-6 col-12">
								<nk-col-form-group :label="`${$t('trs.related-factor-attachments.attached-amount')}:`" :double="true" class="mt-3" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }" :labelAligns="{ xs: 'left' }" style="padding-right:9px">
									<nk-input v-model="localData.entityAttachedAmount" :options="componentOptions.price" :tabindex="107"></nk-input>
									<template #hint>
										<nk-label v-model="localData.entityAttachedAmount" :options="{ type: 'price-letter' }" class="px-1 text-right"></nk-label>
									</template>
								</nk-col-form-group>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-5 col-12">
								<nk-col-form-group :label="$t(`trs.related-factor-attachments.open-modal-on-${settings.targetForm}-save`)" :labelSizes="{ xs: 6, sm: 11 }" :dataSizes="{ xs: 1, sm: 1 }">
									<nk-checkbox type="checkbox" :tabindex="108" :options="componentOptions.alwaysOpen" v-model="openFormOnTransactionSave.value" @update:modelValue="(value) => saveOpenTransactionModal()" />
								</nk-col-form-group>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import $sc from '~/plugins/shortcut.collection.js'
	import { mapGetters, mapState, mapActions } from 'vuex'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import validators, {
		Checker,
		isEmpty,
	} from '~/statics/validators.js'
	import FactorAttachmentsFactorList from '~/views/sale/factors/factor-attachments-factor-list'
	import emptyId from '~/statics/empty-id'

	export default {
		modal: {
			size: 'md',
			stateUID: 'related-factor-attachments-modify',
		},

		props: {
			data: { type: Object },
			options: { type: Object },
		},
		data() {
			return {
				settings: {
					filterFloatingCenterIds: [],
					ignoreValidationsIfEmpty: false,
					targetForm: '', // payment receive transfer
				},
				openFormOnTransactionSave: {
					value: false
				},
				componentOptions: {
					number: {
						required: true,
						mode: 'number',
					},
					price: {
						mode: 'price',
						useDefaultValue: true,
						icon2: '',
					},
					code: {
						mode: 'string',
						required: true,
						searchable: true,
					},
				},
				localData: { transaction: null, factorHeader: {} },
				//attachableAmount: 0,
				originalData: null,
				validators: {
					entityAttachedAmount: validators('required'),
				},
				attachedFactor: '',
				saveButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					icon: 'save',
					isPrimary: true,
					handle() {
						this.checkItemsExist()
					},
				}
			}
		},
		computed: {
			...mapState('appContext', {
				status: (state) => state,
			}),
			...mapGetters({
				getActiveState: 'appStates/getActiveByKey',
			}),
			IsPayment() {
				return this.settings.targetForm === 'payment'
			},
			transaction() {
				if (!this.localData.transaction) return ''
				let desc = this.settings.targetForm === 'transfer' ? this.$t(`trs.transaction.transfer.f.${this.localData.transaction.method?.toLowerCase()}`) : this.$t(
					`trs.trans.${this.IsPayment ? 'p' : 'r'}.${this.localData.transaction.method
					}`
				)
				desc +=
					' - ' +
					this.$t(
						`${this.localData.transaction.method == 'Cheque'
							? 'trs.chq.f.item-number'
							: 'trs.transaction.f.code'
						}`
					) +
					': ' +
					this.localData.transaction.code
				desc += ` - ${this.$t(
					`trs.transaction.f.theirFloatingCenters`
				)}: ${this.settings.targetForm === 'transfer' ? this.localData.transaction.floatingCenterTo?.name : this.localData.transaction.theirFloatingCenters
					.map((x) => x.name)
					.join(' ، ')}`

				return desc
			},
			attachableAmount() {
				if (!this.localData.transaction)
					return 0

				if (!this.localData.factorHeader.id) {
					let sumAttachments = _.sumBy(
						this.settings.attachments.filter((x) => x.rowState != 'deleted' && this.is_payment(x.factorHeader.type) === this.IsPayment),
						function (x) {
							return Number(x.entityAttachedAmount)
						}
					)
					return Math.max(this.localData.transaction.amount - sumAttachments, 0)
				}

				let transaction_attachableAmount = Math.max(
					this.localData.transaction.amount -
					_.sumBy(
						this.settings.attachments.filter((x) => x.rowState != 'deleted' && this.is_payment(x.factorHeader.type) === this.IsPayment),
						function (x) {
							return Number(x.entityAttachedAmount)
						}
					) +
					Number(this.data.entityAttachedAmount),
					0
				)

				//In edit mode, if the invoice changes, the initial value that has been passed to the passed form should no longer be applied
				let factor_attachableAmount = Math.max(
					this.localData.factorHeader.totalUnpaid -
					_.sumBy(
						this.settings.attachments.filter(
							(x) =>
								x.factorHeader.id == this.localData.factorHeader.id &&
								(x.rowState == 'new' || x.rowState == 'changed')
						),
						function (x) {
							return Number(x.temp.changes)
						}
					) +
					(this.localData.factorHeader.id == this.data.factorHeader.id
						? Number(this.data.entityAttachedAmount)
						: 0),
					0
				)
				// if (isEmpty(transaction_attachableAmount))
				// 	return factor_attachableAmount
				return Math.min(factor_attachableAmount, transaction_attachableAmount)
			},
		},
		mounted() {
			this.settings = _.extend({}, this.settings, this.options)
			this.localData = _.extend({}, this.localData, this.data)
			this.fillAttachedFactorData()
			this.prepareWindow(this.$t(`sale.factor-attachments-transaction.title`), [this.saveButton])
			this.componentOptions.price = {
				mode: 'price',
				icon2: this.status.company.currency.name,
			}
			this.openFormOnTransactionSave = this.getActiveState(`Transaction_ShowAttachmentOnSave_${this.settings.targetForm.upperCaseFirstLetter()}`) || {
				id: emptyId,
				key: `Transaction_ShowAttachmentOnSave_${this.settings.targetForm.upperCaseFirstLetter()}`,
				name: this.$t(`trs.related-factor-attachments.open-modal-on-${this.settings.targetForm}-save`),
				isActive: true,
				rowState: 'new',
			}
		},
		created() { },
		methods: {
			...mapActions({
				menu_show: 'hide_show',
				modifyStates: 'appStates/modify',
				syncStates: 'appStates/sync',
				refreshStates: 'appStates/refresh',
			}),
			checkItemsExist() {
				if ((this.settings.ignoreValidationsIfEmpty && !this.localData.factorHeader.id && !this.localData.entityAttachedAmount) || this.validateInputs()) {
					this.saveAndResolve()
				}
			},
			saveAndResolve() {
				let cloned = _.cloneDeep(this.localData)
				this.resolve(cloned)
			},
			validateInputs() {
				let checker = new Checker((name) =>
					this.$t(`sale.factor-attachments.f.${name}`)
				)
				let errors = checker.test(this.localData, this.validators)

				if (errors.length === 0) {
					// check for factor selected
					if (!this.localData.factorHeader.id)
						errors.push({
							key: '',
							error: this.$t('sale.factor-transaction.m.select-factor'),
						})
				}

				if (errors.length === 0) {
					// this means entityAttachedAmount is not null
					if (
						Number(this.localData.entityAttachedAmount) >
						Number(this.attachableAmount)
					)
						errors.push({
							key: '',
							error: this.$t(
								'sale.factor-transaction.m.factor-greater-than-attachable-error'
							),
						})
				}
				this.validationToast(errors)
				return errors.length === 0
			},
			attachableFactorList() {
				var options = {
					mode: 'select',
					isPayment: this.IsPayment,
					factorType: this.settings.targetForm === 'transfer' ? 'All' : (this.IsPayment ? 'Sale' : 'Buy'),
					filterFloatingCenterIds: this.settings.filterFloatingCenterIds,
				}

				this.showModal({
					component: FactorAttachmentsFactorList,
					data: null,
					options,
				})
					.then((result) => {
						if (result) {
							this.localData.factorHeader = result
							var factorAttachable = Math.max(
								result.totalUnpaid -
								_.sumBy(
									this.settings.attachments.filter(
										(m) =>
											m.factorHeader.id == result.id &&
											(m.rowState == 'new' || m.rowState == 'changed')
									),
									function (x) {
										return Number(x.entityAttachedAmount)
									}
								),
								0
							)
							//this.attachableAmount = Math.min(factorAttachable, this.settings.attachableAmount)
							this.localData.entityAttachedAmount = this.attachableAmount
							this.fillAttachedFactorData()
						}
					})
					.catch(() => {
						this.$refs.factorAttachment.$el.focus()
					})
			},
			retreiveIsEmpty() {
				if (isEmpty(this.localData.id)) {
					return false
				} else {
					return true
				}
			},
			saveOpenTransactionModal() {
				if (this.openFormOnTransactionSave.rowState != 'new') {
					this.openFormOnTransactionSave.rowState = 'changed'
				}

				this.modifyStates([this.openFormOnTransactionSave])
				return this.syncStates()
			},
			fillAttachedFactorData() {
				if (this.localData.factorHeader.code)
					this.attachedFactor = `${this.$t(
						`sale.factor.types.${this.localData.factorHeader.type}`
					)} - ${this.$t('sale.factor.f.code')}: ${this.localData.factorHeader.code
						}`
			},
			is_payment(type) {
				return type !== 'Sale' && type !== 'BuyReturn' && type !== 'Proforma'
			}
		},
	}
</script>
<style></style>
